<template>
  <card>
    <div class="properties">
      <property :name="'סוג מנוי'" :value="'פעיל'"/>
      <property :name="'תאריך חיוב הבא'" :value="'מנוי ללא חיוב'"/>
    </div>
  </card>
</template>

<script>
import BaseUI from 'base-ui';
import Property from './Property.vue';

export default {
  name: 'FreeSubscriptionSettings',
  components: {
    Property,
    Card: BaseUI.Card,
  },
};
</script>

<style scoped lang="scss">

  @import "./settings";

  @include properties;

</style>
